import { FormSectionProps } from '../../interfaces/form'
import FormWizard from '../wizard'
// import { lighten } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
// import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

// import FormRadio from '../../components/FormRadio'
import FormField from '../../components/FormField'

const DateOfBirth = () => {
  return (
    <div id="dateOfBirth" style={{ marginBottom: 40 }}>
      <Typography variant="h6" color="secondary" sx={{ marginBottom: 2 }}>
        How old are you?
      </Typography>
      <FormField
        id="age"
        name="age"
        placeholder="Age"
        type="number"
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
      />
      {/* <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <FormField
            id="dateOfBirthDay"
            name="dateOfBirth.day"
            placeholder="DD"
            type="number"
            inputProps={{
              style: { textAlign: 'center' },
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormField
            id="dateOfBirthMonth"
            name="dateOfBirth.month"
            type="number"
            placeholder="MM"
            inputProps={{
              style: { textAlign: 'center' },
              type: 'number',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormField
            id="dateOfBirthYear"
            name="dateOfBirth.year"
            type="number"
            placeholder="YYYY"
            inputProps={{
              style: { textAlign: 'center' },
              type: 'number',
            }}
          />
        </Grid>
      </Grid> */}
    </div>
  )
}

// const Gender = () => {
//   return (
//     <div id="gender" style={{ marginBottom: 40 }}>
//       <Typography variant="h6" color="secondary" sx={{ marginBottom: 2 }}>
//         Are you male or female?
//       </Typography>
//       <Grid container spacing={2} sx={{ mb: 14 }}>
//         <Grid item xs={12} md={3}>
//           <label htmlFor="male" style={{ textAlign: 'center' }}>
//             <FormRadio
//               id="male"
//               name="gender"
//               value="Male"
//               style={radioStyle}
//               overrideMuiStyle={radioOverrideMuiStyle}
//             />
//             <Typography component="span" style={textStyle}>
//               Male
//             </Typography>
//           </label>
//         </Grid>
//         <Grid item xs={12} md={3}>
//           <label htmlFor="female" style={{ textAlign: 'center' }}>
//             <FormRadio
//               id="female"
//               name="gender"
//               value="Female"
//               style={radioStyle}
//               overrideMuiStyle={radioOverrideMuiStyle}
//             />
//             <Typography component="span" style={textStyle}>
//               Female
//             </Typography>
//           </label>
//         </Grid>
//       </Grid>
//     </div>
//   )
// }

const PersonalDetails = ({ validate }: FormSectionProps) => {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <DateOfBirth />
          {/* <Gender /> */}
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default PersonalDetails
